import { createFileRoute, useNavigate } from '@tanstack/react-router';
import { z } from 'zod';
import { SetupScreen } from '../features/setup/SetupScreen.tsx';

export const Route = createFileRoute('/setup')({
  validateSearch: z.object({ token: z.string().catch('') }),
  component: SetupRoute,
});

function SetupRoute() {
  const { token } = Route.useSearch();
  const navigate = useNavigate();
  return <SetupScreen token={token} onDone={() => void navigate({ to: '/recipes' })} />;
}
